import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import Task from "@mui/icons-material/Task";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReportLoadingDialog from "../../Components/ReportLoadingDialog";

toast.configure();

const MkPkPerformance = () => {
  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  const date = new Date();
  const [fromdate, setfromdate] = useState(null);
  const [todate, settodate] = useState(date);
  const [pdfStream, setPdfStream] = useState(null);
  const [loading, setLoading] = useState(false);
  const [genrating, setgenrating] = useState(false);
  const [reportText, setReportText] = useState({
    title: "",
    subtitle: "",
  });

  async function getfromdatedata() {
    try {
      const response = await fetch("/reports/fromdate", {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const jsonData = await response.json();
      setfromdate(jsonData.fromdate);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    getfromdatedata();
  }, []);

  const handlePurchaseData = async (e) => {
    e.preventDefault();
    if (fromdate === null || todate === null) {
      return toast.error("Please Select A valid Date!");
    }

    setLoading(true);
    setReportText({
      title: "Generating MkPk Performance",
      subtitle: "Preparing purchase data report. Please wait...",
    });
    setgenrating(true);

    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      const response = await fetch(
        `/reports/spare/mkpkperformance/purchase/${fromDateStr}/${toDateStr}`,
        {
          method: "GET",
          headers: {
            sptoken: userToken,
          },
        }
      );

      if (!response.ok) {
        const message = await response.text();
        toast.error(message || "Unable to generate report.");
        return;
      }

      const pdfBlob = await response.blob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfStream(pdfUrl);
    } catch (err) {
      console.log(err.message);
      toast.error("Unable to generate report.");
    } finally {
      setLoading(false);
      setgenrating(false);
    }
  };

  const printExcel = async (e) => {
    e.preventDefault();
    if (fromdate === null || todate === null) {
      return toast.error("Please Select A valid Date!");
    }

    setReportText({
      title: "Generating MkPk Performance",
      subtitle: "Preparing Excel report. Please wait...",
    });
    setgenrating(true);

    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      const response = await fetch(
        "/reports/spare/mkpkperformance/purchase/excel",
        {
          method: "POST",
          headers: {
            sptoken: userToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fromdate: fromDateStr, todate: toDateStr }),
        }
      );

      if (!response.ok) {
        const message = await response.text();
        toast.error(message || "No data found for the selected criteria.");
        return;
      }

      const blob = await response.blob();
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = "MkPkPerformancePurchase.xlsx";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(downloadLink.href);
    } catch (err) {
      console.log(err.message);
      toast.error("Unable to generate Excel report.");
    } finally {
      setgenrating(false);
    }
  };

  return (
    <>
      <ReportLoadingDialog
        open={genrating}
        title={reportText.title}
        subtitle={reportText.subtitle}
      />
      <Sidebar
        Title={"MKPK PERFORMANCE"}
        expandedPanel={"panel3"}
        children={
          <Box component="form" sx={{ width: "100%" }} autoComplete="off">
            <Box
              sx={{
                marginTop: "4rem",
                display: "flex",
                flexWrap: "wrap",
                columnGap: "20px",
                justifyContent: "center",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  inputFormat="DD/MM/YYYY"
                  value={fromdate}
                  onChange={(newValue) => {
                    setfromdate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField required {...params} sx={{ width: "20%" }} size="small" />
                  )}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  inputFormat="DD/MM/YYYY"
                  value={todate}
                  onChange={(newValue) => {
                    settodate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField required {...params} sx={{ width: "20%" }} size="small" />
                  )}
                />
              </LocalizationProvider>

              <Button
                type="submit"
                onClick={handlePurchaseData}
                variant="contained"
                disabled={loading === true}
                component="label"
                size="large"
                sx={{ boxShadow: "2px 2px 6px  #404142" }}
                endIcon={<Task />}
              >
                {loading ? "Fetching Data..." : "Purchase Data"}
              </Button>
              <Button
                onClick={printExcel}
                variant="contained"
                color="success"
                disabled={loading === true || genrating === true}
                component="label"
                size="large"
                sx={{ boxShadow: "2px 2px 6px  #404142" }}
                endIcon={<Task />}
              >
                Download Excel
              </Button>
            </Box>
            <Box sx={{ backgroundColor: "white", mt: 2 }}>
              {pdfStream && (
                <iframe
                  src={pdfStream}
                  width="100%"
                  height="680px"
                  title="report"
                ></iframe>
              )}
            </Box>
          </Box>
        }
      />
      {redirectToLoginPage()}
    </>
  );
};

export default MkPkPerformance;
